/* eslint @typescript-eslint/no-var-requires: 0 */

export const commonEnvironment = {
  version: require('../../../../package.json').version,
  appKeyword: 'parents-dashboard'
};
